export const MyElearningTag = 'MyLibrary';
export const CourseLibraryTag = 'CourseLibrary';
export const VideoLibraryTag = 'VideoLibrary';
export const VocamRegionsTag = 'VocamRegions';
export const VocamChannelsTag = 'VocamChannels';
export const VideoPreviewLinkTag = 'VocamPreviewLink';
export const VideoLinkTag = 'VocamLink';
export const ScormVocamVideoLinkTag = 'ScormVocamVideoLinkTag';
export const BreatheVocamVideoLinkTag = 'BreatheVocamVideoLinkTag';
export const MyElearningDetailsTag = 'ElearningDetails';
export const ElearningPulishReviewResult = 'ElearningPulishReviewResult';
export const ResourcesTag = 'Resources';
export const HelperTag = 'Helper';
export const FaqTag = 'Faq';
export const FramesTag = 'Frames';
export const ElearningTag = 'Elearning';
export const TemplatesTag = 'Templates';
export const TemplateTag = 'Template';
export const ThemesTag = 'Themes';
export const ThemeTag = 'Theme';
export const ThemeDefaultTag = 'Theme';
export const QuizzesTag = 'Quizzes';
export const QuizAttemptTag = 'QuizAttempt';
export const QuestionsTag = 'Questions';
export const QuestionTag = 'Question';
export const AuthTag = 'Authentication';
export const UserInfoTag = 'UserInfo';
export const SignedCookieTag = 'SignedCookie';
export const AdminSignedCookieTag = 'AdminSignedCookie';
export const ManifestTag = 'Manifest';
export const ElementTag = 'Elements';
export const ChoicesTag = 'Choices';
export const ReviewersTag = 'Reviewers';
export const ReviewerTag = 'Reviewer';
export const CommentsTag = 'Comments';
export const FrameCommentsTag = 'FrameComments';
export const ReviewerCommentsTag = 'ReviewerComments';
export const ReviewerElearningCommentsTag = 'ReviewerElearningComments';
export const TenantTag = 'Tenant';
export const TenantsTag = 'Tenants';
export const TenantProfileTag = 'TenantProfile';
export const TenantCategoriesTag = 'TenantCategories';
export const CourseLibraryDownloadResultTag = 'CourseLibraryDownloadResult';
export const NavigationsTag = 'Navigations';
export const ElearningCategoriesListTag = 'ElearningCategoriesList';
export const ElearningCategoriesAllowedListTag =
  'ElearningCategoriesAllowedList';
export const ScormCookieTag = 'ScormCookie';
export const ElearningCategoryTag = 'ElearningCategory';
